import cloneDeep from 'lodash.clonedeep';

import {
  WorkHistoryJob,
  addWorkHistoryJob as apiAddWorkHistoryJob,
  deleteWorkHistoryJob as apiDeleteWorkHistoryJob,
  editWorkHistoryJob as apiEditWorkHistoryJob,
  fetchApplicantProfile as apiFetchApplicantProfile,
  updateApplicantProfile as apiUpdateApplicantProfile,
} from 'api/applicantProfile';
import {
  CurrentUser as ApiCurrentUser,
  SavedSearch,
  SavedSearchUnsaved,
  fetchCurrentUser as apiFetchCurrentUser,
  saveListing as apiSaveListing,
  saveSearch as apiSaveSearch,
  setABExperimentBucket as apiSetABExperimentBucket,
  unsaveListing as apiUnsaveListing,
  unsaveSearch as apiUnsaveSearch,
} from 'api/currentUser';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import {
  Dispatch as StaffDispatch,
  GetState as StaffGetState,
} from 'store/staff';
import { trackEvent } from 'utils/analytics';
import { removeId } from 'utils/functional';
import { getItem } from 'utils/localStorage';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch, GetState } from '..';
import { pushFlashMessage } from './flashMessages';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { updateSearchLocation } from './mainSearch';

// Types

type FetchCurrentUserRequestAction = {
  type: 'CURRENT_USER_FETCH_REQUEST';
};
type FetchCurrentUserSuccessAction = {
  type: 'CURRENT_USER_FETCH_SUCCESS';
  currentUser: ApiCurrentUser;
};
type UpdateCurrentUserWith = {
  type: 'CURRENT_USER_UPDATE_PARTIAL';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentUserPartial: Record<string, any>;
};
type SaveListingAction = {
  type: 'SAVE_LISTING';
  listingId: string;
  listingType: string;
};
type UnsaveListingAction = {
  type: 'UNSAVE_LISTING';
  listingId: string;
};
type SaveSearchAction = {
  type: 'SAVE_SEARCH';
  savedSearch: SavedSearch;
};
type UnsaveSearchAction = {
  type: 'UNSAVE_SEARCH';
  searchId: string;
};
type FetchApplicantRequestAction = {
  type: 'APPLICANT_PROFILE_FETCH_REQUEST';
};
type FetchApplicantSuccessAction = {
  type: 'APPLICANT_PROFILE_FETCH_SUCCESS';
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentUserPartial: Record<string, any>;
};
type FetchApplicantFailureAction = {
  type: 'APPLICANT_PROFILE_FETCH_FAILURE';
};
export type Action =
  | FetchCurrentUserRequestAction
  | FetchCurrentUserSuccessAction
  | UpdateCurrentUserWith
  | SaveListingAction
  | UnsaveListingAction
  | SaveSearchAction
  | UnsaveSearchAction
  | FetchApplicantRequestAction
  | FetchApplicantSuccessAction
  | FetchApplicantFailureAction;

// TODO: Fix this the next time the file is edited.

export type CurrentUser = ApiCurrentUser & {
  isFetching?: boolean;
  isLoaded: boolean;
  applicantProfileIsLoaded: boolean;
  applicantProfileIsFetching?: boolean;
};
export type State = CurrentUser;
// @ts-expect-error ts-migrate(2322) FIXME: Type '{}' is not assignable to type 'CurrentUser'.

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/default-param-last
export function currentUserReducer(state: State = {}, action: Action) {
  switch (action.type) {
    case 'CURRENT_USER_FETCH_REQUEST':
      return { ...state, isFetching: true };

    case 'CURRENT_USER_FETCH_SUCCESS':
      return { ...action.currentUser, isFetching: false, isLoaded: true };

    case 'CURRENT_USER_UPDATE_PARTIAL':
      return { ...state, ...action.currentUserPartial };
    case 'SAVE_LISTING': {
      const { listingId, listingType } = action;

      if (
        state.savedListings &&
        state.savedListings.find((listing) => listing.id === listingId)
      ) {
        return state;
      }

      return {
        ...state,
        savedListings: [
          ...(state.savedListings || []),
          {
            id: listingId,
            type: listingType,
          },
        ],
      };
    }

    case 'UNSAVE_LISTING': {
      const { listingId } = action;
      return {
        ...state,
        savedListings: removeId(state.savedListings || [], listingId),
      };
    }

    case 'SAVE_SEARCH': {
      const { savedSearch } = action;

      if (
        state.savedSearches &&
        state.savedSearches.find((search) => search.id === savedSearch.id)
      ) {
        return state;
      }

      return {
        ...state,
        savedSearches: [...(state.savedSearches || []), savedSearch],
      };
    }

    case 'UNSAVE_SEARCH': {
      const { searchId } = action;
      return {
        ...state,
        savedSearches: removeId(state.savedSearches || [], searchId),
      };
    }

    case 'APPLICANT_PROFILE_FETCH_REQUEST':
      return { ...state, applicantProfileIsFetching: true };

    case 'APPLICANT_PROFILE_FETCH_SUCCESS':
      return {
        ...state,
        ...action.currentUserPartial,
        applicantProfileIsFetching: false,
        applicantProfileIsLoaded: true,
      };

    case 'APPLICANT_PROFILE_FETCH_FAILURE':
      return { ...state, applicantProfileIsFetching: false };

    default:
      return state;
  }
}

// Actions

const fetchCurrentUserRequest = (): FetchCurrentUserRequestAction => ({
  type: 'CURRENT_USER_FETCH_REQUEST',
});

const fetchCurrentUserSuccess = (
  currentUser: ApiCurrentUser
): FetchCurrentUserSuccessAction => ({
  type: 'CURRENT_USER_FETCH_SUCCESS',
  currentUser,
});

export const fetchCurrentUser =
  () => (dispatch: Dispatch, getState: GetState) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line prefer-destructuring
    const currentUser = getState().currentUser;

    if (currentUser && currentUser.isFetching) {
      return Promise.resolve() as Promise<void>;
    }

    dispatch(fetchCurrentUserRequest());
    return apiFetchCurrentUser().then((fetchedUser) => {
      // Read searchLocation from localstorage
      // @TODO replace fallback to searchLocation with guessedLocation
      // TODO: Fix this the next time the file is edited.

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      dispatch<any>(
        updateSearchLocation(
          getItem('searchLocation') || fetchedUser.guessedLocation,
          false
        )
      );
      dispatch(fetchCurrentUserSuccess(fetchedUser));
    });
  };
export const fetchCurrentUserForStaff =
  () => (dispatch: StaffDispatch, getState: StaffGetState) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line prefer-destructuring
    const currentUser = getState().currentUser;

    if (currentUser && currentUser.isFetching) {
      return Promise.resolve() as Promise<void>;
    }

    dispatch(fetchCurrentUserRequest());
    return apiFetchCurrentUser().then((fetchedUser) =>
      dispatch(fetchCurrentUserSuccess(fetchedUser))
    );
  };
export const updateCurrentUser = fetchCurrentUserSuccess;
export const updateCurrentUserWith = (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentUserPartial: Record<string, any>
): UpdateCurrentUserWith => ({
  type: 'CURRENT_USER_UPDATE_PARTIAL',
  currentUserPartial,
});
export const saveListing =
  (listingId: string, listingType: string, listingName: string) =>
  (dispatch: Dispatch) => {
    dispatch({
      type: 'SAVE_LISTING',
      listingId,
      listingType,
    });

    if (listingType === 'ORG') {
      dispatch(
        pushFlashMessage({
          type: 'SAVE_ORG',
          data: {
            orgName: listingName,
          },
        })
      );
    } else if (listingType === 'GROUP') {
      dispatch(
        pushFlashMessage({
          type: 'SAVE_GROUP',
          data: {
            groupName: listingName,
          },
        })
      );
    }

    return apiSaveListing(listingId, listingType).catch((error) => {
      dispatch({
        type: 'UNSAVE_LISTING',
        listingId,
        listingType,
      });
      throw error;
    });
  };
export const unsaveListing =
  (listingId: string, listingType: string, listingName: string) =>
  (dispatch: Dispatch) => {
    dispatch({
      type: 'UNSAVE_LISTING',
      listingId,
    });

    if (listingType === 'ORG') {
      dispatch(
        pushFlashMessage({
          type: 'UNSAVE_ORG',
          data: {
            orgName: listingName,
          },
        })
      );
    } else if (listingType === 'GROUP') {
      dispatch(
        pushFlashMessage({
          type: 'UNSAVE_GROUP',
          data: {
            groupName: listingName,
          },
        })
      );
    }

    return apiUnsaveListing(listingId, listingType).catch((error) => {
      // if listing was already removed, ignore error
      if (error.statusCode !== 404) {
        dispatch({
          type: 'SAVE_LISTING',
          listingId,
          listingType,
        });
        throw error;
      }
    });
  };
export const saveSearch =
  (search: SavedSearchUnsaved) => (dispatch: Dispatch) =>
    apiSaveSearch(search).then((savedSearch) => {
      dispatch({
        type: 'SAVE_SEARCH',
        savedSearch,
      });
      dispatch(
        pushFlashMessage({
          type: 'SAVED_SEARCH',
        })
      );
      trackEvent('Created Email Alert');
    });
export const unsaveSearch = (searchId: string) => (dispatch: Dispatch) =>
  apiUnsaveSearch(searchId).then(() => {
    dispatch({
      type: 'UNSAVE_SEARCH',
      searchId,
    });
    dispatch(
      pushFlashMessage({
        type: 'UNSAVED_SEARCH',
      })
    );
  });
export const setABExperimentBucket =
  (experimentId: string, bucket?: string) =>
  (dispatch: Dispatch, getState: GetState) => {
    const currentUser = cloneDeep(getState().currentUser);
    return apiSetABExperimentBucket(experimentId, bucket).then(
      (abExperiments) => {
        currentUser.abExperiments = abExperiments;
        dispatch(updateCurrentUser(currentUser));
        return abExperiments;
      }
    );
  };

const dispatchProfileUpdate = (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  request: (...args: Array<any>) => any,
  dispatch: Dispatch
) => {
  dispatch({
    type: 'APPLICANT_PROFILE_FETCH_REQUEST',
  });
  return request()
    .then((currentUserPartial) => {
      dispatch({
        type: 'APPLICANT_PROFILE_FETCH_SUCCESS',
        currentUserPartial,
      });
    })
    .catch((error) => {
      dispatch({
        type: 'APPLICANT_PROFILE_FETCH_FAILURE',
      });
      throw error;
    });
};

export const fetchApplicantProfile = () => (dispatch: Dispatch) =>
  dispatchProfileUpdate(() => apiFetchApplicantProfile(), dispatch);
export const updateApplicantProfile =
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (values: Record<string, any>) => (dispatch: Dispatch) =>
    dispatchProfileUpdate(() => apiUpdateApplicantProfile(values), dispatch);
export const updateWorkHistoryJob =
  (job: WorkHistoryJob, id: string | null | undefined) =>
  (dispatch: Dispatch) => {
    const submit = () =>
      id ? apiEditWorkHistoryJob(id, job) : apiAddWorkHistoryJob(job);

    return dispatchProfileUpdate(() => submit(), dispatch);
  };
export const deleteWorkHistoryJob = (id: string) => (dispatch: Dispatch) =>
  dispatchProfileUpdate(() => apiDeleteWorkHistoryJob(id), dispatch);
